var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 0h24v24H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 20h14a1 1 0 0 0 1-1v-8.343a4 4 0 0 0-1.172-2.829l-2.656-2.656A4 4 0 0 0 13.843 4H5.5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1zM7.5 14.5H17M7.5 10h6",
    stroke: "#FFF",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents-icon.2c2403f3b60dc830da80ff6d9062ce75.svg";
export { ForwardRef as ReactComponent };